// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33SYt","content":"styles_content__2p1qa"};